// Lets the per-message debug affordance reach the hosting page's debug rail
// without threading a callback through the registry. Hosts that own a rail
// provide an opener; when absent the affordance hides, so surfaces without a
// rail cannot expose a control that silently does nothing.
import { createContext, useContext } from 'react';

export type OpenMessageDebug = (committedEventId: string) => void;

export const MessageDebugContext = createContext<OpenMessageDebug | null>(null);

export function useOpenMessageDebug(): OpenMessageDebug | null {
    return useContext(MessageDebugContext);
}
